import {
  NgModule
} from '@angular/core';
import {
  ButtonsModule
} from '@progress/kendo-angular-buttons';
import {ReactiveFormsModule} from '@angular/forms';
import {FloatingLabelModule} from '@progress/kendo-angular-label';
import {VariantComponent} from './variant.component';
import {GridModule} from '@progress/kendo-angular-grid';
import {CheckBoxModule} from '@progress/kendo-angular-inputs';
import {CommonModule} from '@angular/common';

@NgModule({
  declarations: [
    VariantComponent
  ],
  imports: [
    ButtonsModule,
    ReactiveFormsModule,
    GridModule,
    CommonModule,
    CheckBoxModule,
    FloatingLabelModule
  ],
  exports: [
    VariantComponent
  ],
  providers: [
  ],
  entryComponents: [
  ]
})
export class VariantModule {
}
